import type { GmUserProfileViewProps } from '../types';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';
import { useTranslations } from 'next-intl';
import { GmStatusImage } from '@/components/entities/gamification/GmStatusImage';
import { ProfileEmailAndIdFields } from '@/components/entities/profile/ProfileEmailAndIdFields';
import { Icon } from '@/components/entities/Sprite';
import { Drawer, DrawerContent, DrawerDescription, DrawerHandle, DrawerHeader, DrawerTitle } from '@/components/ui/Drawer/drawer';
import { Link } from '@/i18n/routing';

export const GmUserProfileMobile = ({ isOpen, onOpenChange, statusName = '', statusImageSrc, user }: GmUserProfileViewProps) => {
  const t = useTranslations();

  return (
    <Drawer
      open={isOpen}
      direction="top"
      onOpenChange={onOpenChange}
      repositionInputs={false}
    >
      <DrawerContent
        overlayClassName="!top-16 !z-30"
        className="top-16! z-30! rounded-b-2xl! border-none bg-(image:--gradients-popup-desktop) px-5 pb-3.5 pt-5 shadow-card"
      >
        <DrawerHeader className="px-0 py-0">
          <VisuallyHidden.Root>
            <DrawerTitle>Profile player info</DrawerTitle>
            <DrawerDescription>Profile player info</DrawerDescription>
          </VisuallyHidden.Root>
        </DrawerHeader>
        <div className="flex max-w-150 mx-auto flex-col">
          <div className="mb-4 flex items-center justify-between gap-3">
            <div className="flex items-center gap-2">
              {
                statusImageSrc && (
                  <GmStatusImage
                    src={statusImageSrc}
                    alt={statusName || 'Status icon'}
                    className="size-8 shrink-0 object-contain"
                  />
                )
              }

              <p className="truncate text-white paragraph-s-medium">
                {t('gamification.widget-bar.your-status', { status: statusName })}
              </p>
            </div>
            <Link
              href="/profile"
              prefetch={false}
              onClick={() => onOpenChange(false)}
              className="flex shrink-0 cursor-pointer items-center gap-1.5 text-white transition-all paragraph-s-medium duration-300"
            >
              {t('user-profile.information.my-profile')}
              <Icon name="arrow-right" className="size-3 text-white" />
            </Link>
          </div>
          <ProfileEmailAndIdFields appearance="gmMobile" email={user?.email} userId={user?.id} />

          <DrawerHandle className="mt-6 data-vaul-handle:bg-c600! data-vaul-handle:w-9!" />
        </div>
      </DrawerContent>
    </Drawer>
  );
};
